// extracted by mini-css-extract-plugin
export default {"container":"DnfBuilderPage-module__container___wiNKL","sidebar-expanded":"DnfBuilderPage-module__sidebar-expanded___Mo0ZL"};